import React, { useState, useEffect, useRef } from "react";
import MUIDataTable from "mui-datatables";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import { Checkbox, Paper } from "@mui/material";
import { Input, Tooltip, Typography, Box } from "@mui/material";
import { grey } from "@mui/material/colors";
import Fab from "@mui/material/Fab";
import PrintIcon from "@mui/icons-material/Print";
import EditIcon from "@mui/icons-material/Edit";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import IconButton from "@mui/material/IconButton";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import CheckIcon from "@mui/icons-material/Check";
import SendIcon from "@mui/icons-material/Send";
import Chip from "@mui/material/Chip";
import PreviewIcon from "@mui/icons-material/Preview";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";

export default function useDatatableAddon(state, setState, id, addonOptions) {
  const location = useLocation();
  const [currentPage, setCurrentPage] = useState(location.state?.currentPage);
  const [searchText, setSearchText] = useState(location.state?.searchText);
  const [rowEdit, setRowEdit] = useState();
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [originalRow, setOriginalRow] = useState(false);
  const tableState = {};
  const [open, setOpen] = React.useState(false);
  const [focus, setFocus] = useState(addonOptions.focus || 1);
  const [currentData, setCurrentData] = useState();
  const [cntrl, setCntrl] = useState(false);
  const [rowInEditing, setRowInEditing] = useState();

  const filter = createFilterOptions();

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    // console.log("rowEdit", rowEdit);
    // const timeout = setTimeout(() => {
    //   focus.current.focus();
    // }, 100);

    return () => {
      // clearTimeout(timeout);
    };
  }, [rowEdit]);

  const handleKeyDown = (e, tableMeta, options) => {
    if (options?.tabNext === true) {
      if (e.code === "Tab") {
        addonOptions?.save(tableMeta).then((result) => {
          const rowsPerPage = tableMeta.tableState.rowsPerPage;

          const rowIndex = tableMeta.rowIndex;

          const finishedPage = Number.isInteger((rowIndex + 1) / rowsPerPage);

          if (finishedPage) {
            setCurrentPage((rowIndex + 1) / rowsPerPage);
          }

          if (rowEdit + 1 === tableState.state.data.length) {
            newRecord(addonOptions.record);
          }

          setRowEdit(rowEdit + 1);

          addonOptions?.edit?.(tableMeta);
        });
      }
    }

    if (e.code === "ControlLeft" || e.code === "ControlRight") {
      setCntrl(true);
    } else if (e.code === "ArrowDown") {
      if (cntrl === true) {
        e.preventDefault();

        setFocus(tableMeta.columnIndex);

        addonOptions?.save(tableMeta).then((result) => {
          const rowsPerPage = tableMeta.tableState.rowsPerPage;

          const rowIndex = tableMeta.rowIndex;

          const finishedPage = Number.isInteger((rowIndex + 1) / rowsPerPage);

          if (finishedPage) {
            setCurrentPage((rowIndex + 1) / rowsPerPage);
          }

          if (rowEdit + 1 === tableState.state.data.length) {
            newRecord(addonOptions.record);
          }

          setRowEdit(rowEdit + 1);

          addonOptions?.edit?.(tableMeta);
        });
      }
    } else if (e.code === "ArrowUp") {
      if (cntrl === true) {
        e.preventDefault();

        setFocus(tableMeta.columnIndex);

        addonOptions?.save(tableMeta).then((result) => {
          const rowsPerPage = tableMeta.tableState.rowsPerPage;

          const rowIndex = tableMeta.rowIndex;

          const finishedPage = Number.isInteger(rowIndex / rowsPerPage);

          // console.log(rowIndex, rowsPerPage, finishedPage, "up");

          if (finishedPage && rowIndex / rowsPerPage !== 0) {
            setCurrentPage(rowIndex / rowsPerPage - 1);
          }

          setRowEdit(rowEdit - 1);

          addonOptions?.edit?.(tableMeta);
        });
      }
    }
  };

  const handleChange = (tableMeta, e, updateValue, newValue, options) => {
    // console.log(newValue);
    const copyState = [...state];

    const row = copyState.find((item) => item[id] === tableMeta.rowData[0]);

    if (options?.type === "number") {
      row[tableMeta.columnData.name] =
        e.target.value === "" ? null : Number(e.target.value);
    } else {
      row[tableMeta.columnData.name] = newValue || e.target.value;
    }

    updateValue?.(newValue || e.target.value);
    setState(copyState);
  };

  const options = {
    filterType: "multiselect",
    responsive: "scroll",
    selectableRows: "none",
    searchText: searchText,
    page: currentPage,
    rowsPerPage: addonOptions.rowsPerPage || rowsPerPage,
    rowsPerPageOptions: [5, 10, 20, 50, 100, 1000],
    onTableChange: (action, state) => (tableState.state = state),
    onChangePage: (currentPage) => setCurrentPage(currentPage),
    onSearchChange: (searchText) => setSearchText(searchText),
    onChangeRowsPerPage: (rowsPerPage) => {
      setRowsPerPage(rowsPerPage);
    },
  };

  const actions = {
    name: "actions",
    label: "Actions",
    options: {
      viewColumns: false,
      filter: false,
      sort: false,
      customBodyRender: (value, tableMeta, updateValue) => {
        if (tableMeta.rowIndex === rowEdit) {
          return (
            <Box sx={{ width: "100px" }}>
              <Tooltip title="Dont Save">
                <CloseIcon
                  onClick={() => {
                    //reset row data from saved data
                    const copyState = [...state];

                    const rowIndex = copyState.findIndex(
                      (item) => item[id] === tableMeta.rowData[0]
                    );

                    copyState[rowIndex] = { ...originalRow };

                    setState(copyState);

                    setRowEdit(null);
                  }}
                />
              </Tooltip>

              <Tooltip title="Save">
                <SaveIcon
                  sx={{ marginLeft: "5px", color: "primary.main" }}
                  onClick={() => {
                    //save row function goes here
                    addonOptions?.save?.(tableMeta);

                    setRowEdit(null);
                  }}
                />
              </Tooltip>
            </Box>
          );
        } else {
          return (
            <Box sx={{ minWidth: "100px" }}>
              <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                <DialogTitle id="alert-dialog-title">
                  {"Are you sure you want to DELETE this?"}
                </DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    If you delete this you will not be able to go back.
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleClose}>Cancel</Button>
                  <Button
                    variant="contained"
                    color="error"
                    autoFocus
                    onClick={() => {
                      handleClose();
                      //delete row function goes here
                      //1) delete from database
                      addonOptions?.delete?.(currentData);

                      //2) delete from array
                      const copyState = [...state];
                      // console.log(copyState);

                      const rowIndex = copyState.findIndex(
                        (item) => item[id] === currentData.rowData[0]
                      );

                      copyState.splice(rowIndex, 1);

                      setRowEdit(null);
                      setState(copyState);
                    }}
                  >
                    Delete
                  </Button>
                </DialogActions>
              </Dialog>
              {!addonOptions?.edit ? null : (
                <Tooltip title="Edit">
                  <EditIcon
                    onClick={() => {
                      addonOptions?.edit?.(tableMeta);
                      // console.log(tableMeta)
                      // save row data here
                      const copyState = [...state];

                      const row = copyState.find(
                        (item) => item[id] === tableMeta.rowData[0]
                      );

                      setOriginalRow({ ...row });
                      setRowInEditing([tableMeta.rowData])

                      setRowEdit(tableMeta.rowIndex);
                    }}
                  />
                </Tooltip>
              )}
              {!addonOptions?.delete ? null : (
                <Tooltip title="Delete">
                  <DeleteForeverIcon
                    sx={{ marginLeft: "5px", color: "error.light" }}
                    onClick={() => {
                      setCurrentData(tableMeta);
                      //open dialog
                      setOpen(true);
                    }}
                  />
                </Tooltip>
              )}
              {!addonOptions?.check ? null : (
                <Tooltip title="Delete">
                  <CheckIcon
                    fontSize="large"
                    sx={{ color: "primary.light" }}
                    onClick={() => {
                      setCurrentData(tableMeta);
                      //open dialog
                      addonOptions.check(tableMeta);
                    }}
                  />
                </Tooltip>
              )}
              {!addonOptions?.uncheck ? null : (
                <Tooltip title="Delete">
                  <CloseIcon
                    fontSize="large"
                    sx={{ marginLeft: "20px", color: "error.light" }}
                    onClick={() => {
                      setCurrentData(tableMeta);
                      //open dialog
                      addonOptions.uncheck(tableMeta);
                    }}
                  />
                </Tooltip>
              )}
              {addonOptions?.open ? (
                <Tooltip title="Open">
                  <OpenInNewIcon
                    sx={{ marginLeft: "5px", color: "primary.main" }}
                    onClick={() => {
                      addonOptions?.open?.(tableMeta);
                    }}
                  />
                </Tooltip>
              ) : null}
              {addonOptions?.send ? (
                <Tooltip title="Send password reset email">
                  <SendIcon
                    sx={{ marginLeft: "5px", color: "primary.main" }}
                    onClick={() => {
                      addonOptions?.send?.(tableMeta);
                    }}
                  />
                </Tooltip>
              ) : null}
              {addonOptions?.preview ? (
                <Tooltip title="Preview">
                  <PreviewIcon
                    sx={{ marginLeft: "5px", color: "primary.main" }}
                    onClick={() => {
                      addonOptions?.preview?.(tableMeta);
                    }}
                  />
                </Tooltip>
              ) : null}
              {addonOptions?.print ? (
                <Tooltip title="Print">
                  <PreviewIcon
                    sx={{ marginLeft: "5px", color: "primary.main" }}
                    onClick={() => {
                      addonOptions?.print?.(tableMeta);
                    }}
                  />
                </Tooltip>
              ) : null}
            </Box>
          );
        }
      },
    },
  };

  const newRecord = (record) => {
    const copyState = [...state];

    const newState = [...copyState, record];

    setState(newState);

    setRowEdit(state.length);

    const rows = tableState.state.data.length;

    const lastPage = Math.trunc(rows / tableState.state.rowsPerPage);

    setCurrentPage(lastPage);
  };

  const textField = (tableMeta, value, options, updateValue) => {
    if (tableMeta.rowIndex === rowEdit || options?.editAlways) {
      return (
        <TextField
          id="outlined-basic"
          size="small"
          label={tableMeta.columnData.label}
          autoFocus={tableMeta.columnIndex === focus ? true : false}
          variant="outlined"
          type={options?.type}
          step={options?.step}
          sx={{ width: options?.width }}
          key={tableMeta.rowIndex + tableMeta.columnData.label}
          disabled={options?.disabled}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">{options?.label}</InputAdornment>
            ),
          }}
          onKeyUp={(e) => {
            setTimeout(() => setFocus(addonOptions.focus || 1), 2000);

            if (e.code === "ControlLeft" || e.code === "ControlRight") {
              setCntrl(false);
            }
          }}
          onKeyDown={(e) => {
            handleKeyDown(e, tableMeta, options);
          }}
          onClick={(e) => {
            // console.log("clickeda this");
            e.preventDefault();
            e.stopPropagation();
            return;
          }}
          onBlur={(e) => options?.check?.(e, tableMeta.rowData[0])}
          onChange={(e, newValue) =>
            handleChange(tableMeta, e, updateValue, newValue, options)
          }
          value={value}
        />
      );
    } else {
      return (
        <Typography
          variant="body2"
          key={tableMeta.rowIndex + tableMeta.columnData.label}
        >{`${options?.label || ""}${value || ""}`}</Typography>
      );
    }
  };

  const selectField = (tableMeta, value, options, updateValue) => {
    // console.log(tableMeta.columnIndex, focus, "newtest select");

    if (tableMeta.rowIndex === rowEdit) {
      return (
        <Autocomplete
          value={value}
          size="small"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">{options?.label}</InputAdornment>
            ),
          }}
          autoSelect={false}
          sx={{ minWidth: options?.width }}
          selectOnFocus
          clearOnBlur
          handleHomeEndKeys
          key={tableMeta.rowIndex + tableMeta.columnData.label}
          onOpen={(e) => options.onOpen?.()}
          isOptionEqualToValue={(option, value) => option.title === value.title}
          onChange={(e, newValue) => {
            options?.onChange?.(newValue);

            const copyState = [...state];

            const row = copyState.find(
              (item) => item[id] === tableMeta.rowData[0]
            );

            // console.log("onChange", row[tableMeta.columnData.name], newValue);

            if (options.id) {
              if (newValue !== null) {
                row[options.id] = newValue[options.id];
              } else {
                row[options.id] = newValue;
              }
            }

            if (typeof newValue === "string") {
              row[tableMeta.columnData.name] = newValue.title;

              updateValue?.({
                title: newValue,
              });
              setState(copyState);
            } else if (newValue && newValue.inputValue) {
              // Create a new value from the user input
              row[tableMeta.columnData.name] = newValue.inputValue;

              updateValue?.({
                title: newValue.inputValue,
              });

              setState(copyState);
            } else {
              if (newValue !== null) {
                row[tableMeta.columnData.name] = newValue.title;
              } else {
                row[tableMeta.columnData.name] = newValue;
              }

              updateValue?.(newValue);
              setState(copyState);
            }
          }}
          onKeyUp={(e) => {
            setTimeout(() => setFocus(addonOptions.focus || 1), 2000);

            if (e.code === "ControlLeft" || e.code === "ControlRight") {
              setCntrl(false);
            }
          }}
          onKeyDown={(e) => {
            handleKeyDown(e, tableMeta, options);
          }}
          options={options?.values || []}
          getOptionLabel={(option) => {
            // Value selected with enter, right from the input
            if (typeof option === "string") {
              return option;
            }
            // Add "xxx" option created dynamically
            if (option.inputValue) {
              return option.inputValue;
            }
            // Regular option
            return option.title;
          }}
          filterOptions={(filterOptions, params) => {
            const filtered = filter(filterOptions, params);

            const { inputValue } = params;

            // Suggest the creation of a new value
            const isExisting = filterOptions.some(
              (option) => inputValue === option.title
            );

            if (inputValue !== "" && !isExisting && options.add) {
              filtered.push({
                inputValue,
                title: (
                  <Box
                    sx={{ color: "primary.light", marginLeft: "10px" }}
                  >{`Create "${inputValue}"`}</Box>
                ),
              });
            }

            return filtered;
          }}
          renderOption={(props, option) => <li {...props}>{option.title}</li>}
          renderInput={(params) => (
            <TextField
              {...params}
              sx={{ minWidth: options?.width }}
              label={tableMeta.columnData.label}
              autoFocus={tableMeta.columnIndex === focus ? true : false}
            />
          )}
        />
      );
    } else {
      return (
        <Typography
          variant="body2"
          key={tableMeta.rowIndex + tableMeta.columnData.label}
        >{`${options?.label || ""}${value || ""}`}</Typography>
      );
    }
  };

  const multipleSelect = (tableMeta, value, options, updateValue) => {
    if (tableMeta.rowIndex === rowEdit) {
      // console.log("value", value);
      return (
        <Autocomplete
          value={value || []}
          sx={{ minWidth: options?.width }}
          size="small"
          multiple
          key={tableMeta.rowIndex + tableMeta.columnData.label}
          // id="tags-filled"
          options={options.values || []}
          freeSolo
          renderTags={(value, getTagProps) =>
            value.map((option, index) => (
              <Chip
                variant="outlined"
                label={option}
                {...getTagProps({ index })}
              />
            ))
          }
          onChange={(e, newValue) =>
            handleChange(tableMeta, e, updateValue, newValue, options)
          }
          onKeyUp={(e) => {
            setTimeout(() => setFocus(addonOptions.focus || 1), 2000);

            if (e.code === "ControlLeft" || e.code === "ControlRight") {
              setCntrl(false);
            }
          }}
          onKeyDown={(e) => {
            handleKeyDown(e, tableMeta, options);
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              // variant="filled"
              label={tableMeta.columnData.label}
            />
          )}
        />
      );
    } else {
      return value?.map((item, index) => (
        <Typography
          variant="body2"
          key={tableMeta.rowIndex + tableMeta.columnData.label + index}
        >{`${item}${index === value.length - 1 ? "" : ", "}`}</Typography>
      ));
    }
  };

  const checkboxField = (tableMeta, value, options, updateValue) => {
    const copyState = [...state];
    // console.log(tableMeta);

    const row = copyState.find((item) => item[id] === tableMeta.rowData[0]);
    if (tableMeta.rowIndex === rowEdit || options?.editAlways) {
      return (
        <Checkbox
          key={tableMeta.rowData[3] + tableMeta.rowIndex}
          onChange={(e) => {
            // console.log(e);
            row[tableMeta.columnData.name] = e.target.checked;

            updateValue?.(e.target.checked);
            setState(copyState);
          }}
          checked={value || false}
        />
      );
    } else {
      return <Checkbox checked={value} disabled="true" />;
    }
  };

  const dateField = (tableMeta, value, options, updateValue) => {
    const copyState = [...state];

    const row = copyState.find((item) => item[id] === tableMeta.rowData[0]);
    // console.log(value, row);

    const options2 = {
      timeZone: "America/New_York",
      weekday: "long",
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
    };

    if (tableMeta.rowIndex === rowEdit || options?.editAlways) {
      return (
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <DateTimePicker
            label={tableMeta.columnData.label}
            openTo="day"
            // views={["year", "month", "day", "hour"]}
            value={value}
            onChange={(newValue) => {
              row[tableMeta.columnData.name] = newValue;

              updateValue?.(newValue);
              setState(copyState);
            }}
            renderInput={(params) => <TextField {...params} />}
          />
        </LocalizationProvider>
      );
    } else {
      return (
        <Typography
          variant="body2"
          key={tableMeta.rowIndex + tableMeta.columnData.label}
        >{`${options?.label || ""}${
          new Date(value).toLocaleDateString("en-US", options2) || ""
        }`}</Typography>
      );
    }
  };

  const bigTextField = (tableMeta, value, options, updateValue) => {
    if (tableMeta.rowIndex === rowEdit || options?.editAlways) {
      return (
        <TextField
          id="outlined-basic"
          size="small"
          multiline
          rows={4}
          fullWidth
          label={tableMeta.columnData.label}
          autoFocus={tableMeta.columnIndex === focus ? true : false}
          variant="outlined"
          type={options?.type}
          step={options?.step}
          sx={{ width: options?.width }}
          key={tableMeta.rowIndex + tableMeta.columnData.label}
          disabled={options?.disabled}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">{options?.label}</InputAdornment>
            ),
          }}
          onKeyUp={(e) => {
            setTimeout(() => setFocus(addonOptions.focus || 1), 2000);

            if (e.code === "ControlLeft" || e.code === "ControlRight") {
              setCntrl(false);
            }
          }}
          onKeyDown={(e) => {
            handleKeyDown(e, tableMeta, options);
          }}
          onClick={(e) => {
            // console.log("clickeda this");
            e.preventDefault();
            e.stopPropagation();
            return;
          }}
          onBlur={(e) => options?.check?.(e, tableMeta.rowData[0])}
          onChange={(e, newValue) =>
            handleChange(tableMeta, e, updateValue, newValue, options)
          }
          value={value}
        />
      );
    } else {
      return (
        <Typography
          variant="body2"
          key={tableMeta.rowIndex + tableMeta.columnData.label}
        >{`${options?.label || ""}${value || ""}`}</Typography>
      );
    }
  };

  return [
    textField,
    selectField,
    newRecord,
    actions,
    options,
    checkboxField,
    multipleSelect,
    dateField,
    bigTextField,
  ];
}
